import { isUnresolvedCategory } from '@folio/utils/document-categories';

export type StopDocument = { id: string; category?: string | null };
export type StopConformity = {
  documentId: string;
  category: string;
  decision: string;
  reason?: string;
};

/** Mirrors the backend gate so the funnel can tell the requester what is still missing. */
export const missingStopDocuments = ({
  requiredCategories,
  documents,
  conformities,
}: {
  requiredCategories: string[];
  documents: StopDocument[];
  conformities: StopConformity[];
}): string[] => {
  const rejectedDocumentIds = new Set(
    conformities
      .filter(({ decision }) => decision === 'REJECTED')
      .map(({ documentId }) => documentId),
  );

  const provided = new Set(
    documents
      .filter(({ id, category }) => !rejectedDocumentIds.has(id) && !isUnresolvedCategory(category))
      .map(({ category }) => category),
  );

  return requiredCategories.filter(category => !provided.has(category));
};

/** A submitted request is the manager's to judge; a refusal reopens it as a draft, which reopens this. */
export const canDeleteStopDocuments = ({
  hasDeletePermission,
  isAwaitingValidation,
}: {
  hasDeletePermission: boolean;
  isAwaitingValidation: boolean;
}): boolean => hasDeletePermission && !isAwaitingValidation;

export const rejectedStopDocuments = ({
  requiredCategories,
  conformities,
}: {
  requiredCategories: string[];
  conformities: StopConformity[];
}): StopConformity[] =>
  conformities.filter(
    ({ decision, category }) => decision === 'REJECTED' && requiredCategories.includes(category),
  );
